import React from "react";
import {LookDataType} from "./LookTypes";
import {useTranslation} from "react-i18next";

const TagsBlock: React.FC<{look: LookDataType; isMobile: boolean}> = ({isMobile, look}) => {
  const {t} = useTranslation();

  const tagClass = isMobile ? "mobile-tag" : "tag";

  return (
    <div className={`${tagClass}s`}>
      {look.tags.map((tag) => {
        const [namespace, value] = tag.split(":");
        if (namespace.endsWith("hidden")) return null;

        return (
          <a
            key={tag}
            className={tagClass}
            href={`/shopthelook.html?taglist=${tag}`}
            title={t("shopthelook.allLooksTo--tag", {tag: value})}
          >
            #{value}
          </a>
        );
      })}
    </div>
  );
};

export default TagsBlock;
